import React, { useState, useEffect } from 'react';
import CariRekanan from './CariRekanan';
import CariRute from './CariRute';

function InputPo({ onCancel, onSave, editMode, pasang, title }) {
  const [tglTransaksi, setTglTransaksi] = useState('');
  const [noTransaksi, setNoTransaksi] = useState('');
  const [kdRekanan, setKdRekanan] = useState('');
  const [namaRekanan, setNamaRekanan] = useState('');
  const [kotaAsal, setKotaAsal] = useState('');
  const [kotaTujuan, setKotaTujuan] = useState('');
  const [subcity, setSubcity] = useState('');
  const [jnsKendaraan, setJnsKendaraan] = useState('');
  const [jnsMuatan, setJnsMuatan] = useState('');
  const [tglPo, setTglPo] = useState('');
  const [noPo, setNoPo] = useState('');
  const [viaPo, setViaPo] = useState('');
  const [keterangan, setKeterangan] = useState('');
  const [status, setStatus] = useState('');
  const [namaUser, setNamaUser] = useState('');
  const [idUser, setIdUser] = useState('');
  const [nama_ttd1, setNama_ttd1] = useState('');
  const [is_admin, setIs_admin] = useState('');  
  const [showRekananLookup, setShowRekananLookup] = useState(false);
  const [showRuteLookup, setShowRuteLookup] = useState(false);
  const [canUnvalid, setCanUnvalid] = useState(true);
  const schema = localStorage.getItem('schema');

useEffect(() => {
  const today = new Date();
  const formattedToday = today.toISOString().split('T')[0];  

  if (editMode && pasang) {
    const { master } = pasang;
      setTglTransaksi(formatDateForInput(master.TGL_TRANSAKSI));
      setNoTransaksi(master.NO_TRANSAKSI || '');
      setKdRekanan(master.KD_REKANAN || '');
      setNamaRekanan(master.NAMAREKANAN || '');
      setKotaAsal(master.KOTA_ASAL || '');
      setKotaTujuan(master.KOTA_TUJUAN || '');
      setSubcity(master.SUBCITY || '');
      setJnsKendaraan(master.JNS_KENDARAAN || '');
      setJnsMuatan(master.JNS_MUATAN || '');
      setTglPo(formatDateForInput(master.TGL_PO));
      setNoPo(master.NO_PO || '');
      setViaPo(master.VIA_PO || 'PHONE');
      setKeterangan(master.KETERANGAN || '');
      setStatus(master.STATUS || '');
      setNama_ttd1(master.NAMA_TTD1 || '');
  } else if (pasang?.isNew) {
    setNoTransaksi(0);
    setTglTransaksi(formattedToday);
    setTglPo(formattedToday);
  }


  const storedUser = localStorage.getItem('nama_user') || '';
  const idUser = localStorage.getItem('id_user') || '';  
  const is_admin = localStorage.getItem('is_admin') || '';  
  setNamaUser(storedUser);
  setIdUser(idUser);
  setIs_admin(is_admin);
}, [editMode, pasang]);


const formatDateForInput = (dateString) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  if (isNaN(date)) return '';
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const day = date.getDate().toString().padStart(2, '0');
  return `${year}-${month}-${day}`;
};

useEffect(() => {
  const checkUnvalidPermission = async () => {
    try {
      if (!nama_ttd1 || !idUser || !is_admin) return;  

      if (is_admin === 'F') {
        if (idUser === nama_ttd1) {
          const url = `${process.env.REACT_APP_API_BASE_URL}/utama.php?caller=unvalid&schema=${schema}&id_user=${idUser}&tipe=1&id_program=PurchaseOrder1`;

          const response = await fetch(url);
          const data = await response.json();

          if (Array.isArray(data) && data.length > 0 && data[0].BUKA === 'F') {
            setCanUnvalid(false);
          } else {
            setCanUnvalid(true);
          }
        } else {
          setCanUnvalid(false);
        }
      } else {
        setCanUnvalid(true);
      }
    } catch (error) {
      console.error('Gagal cek izin unvalid:', error);
      setCanUnvalid(false);
    }
  };

  checkUnvalidPermission();
}, [nama_ttd1, idUser, is_admin]);

const handleValidasi = async () => {
  const id = noTransaksi || '0';

  if (!id || !kdRekanan || !namaRekanan || !kotaAsal || !kotaTujuan) {
    alert('Mohon lengkapi data penting seperti Rekanan dan Rute.');
    return;
  }

  try {
    const formData = new URLSearchParams();
    formData.append('caller', 'po');
    formData.append('id', id);
    formData.append('schema', schema);
    formData.append('id_user', idUser);
    formData.append('tgl_transaksi', tglTransaksi);
    formData.append('kd_rekanan', kdRekanan);
    formData.append('rekanan', namaRekanan);
    formData.append('jns_muatan', jnsMuatan);
    formData.append('jns_kendaraan', jnsKendaraan);
    formData.append('kota_asal', kotaAsal);
    formData.append('kota_tujuan', kotaTujuan);
    formData.append('subcity', subcity);
    formData.append('tgl_po', tglPo);
    formData.append('no_po', noPo);
    formData.append('via_po', viaPo || 'PHONE');    
    formData.append('keterangan', keterangan);    

    const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/po.php`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: formData.toString(),
    });

    const result = await response.json();

    if (result.status === 'success') {
      alert('PO berhasil divalidasi.');
      onSave();  
    } else {
      alert(`Gagal validasi: ${result.message}`);
    }
  } catch (err) {
    console.error('Validasi error:', err);
    alert('Terjadi kesalahan saat validasi PO.');
  }
};


const handleUnvalid = async () => {
  const id = noTransaksi || '0';

  try {
    const formData = new URLSearchParams();
    formData.append('caller', 'po_unvalid');
    formData.append('id', id);
    formData.append('schema', schema);

    const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/po.php`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: formData.toString(),
    });

    const result = await response.json();

    if (result.status === 'success') {
      setStatus('0');
      alert('PO berhasil unvalid');
      //onSave();  
    } else {
      alert(`Gagal validasi: ${result.message}`);
    }
  } catch (err) {
    console.error('Validasi error:', err);
    alert('Terjadi kesalahan saat validasi PO.');
  }
};


const handleDelete = async () => {
  const id = noTransaksi || '0';

  try {
    const formData = new URLSearchParams();
    formData.append('caller', 'po_hapus');
    formData.append('id', id);
    formData.append('schema', schema);

    const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/po.php`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: formData.toString(),
    });

    const result = await response.json();

    if (result.status === 'success') {
      alert('PO berhasil dihapus');
      onSave();  
    } else {
      alert(`Gagal validasi: ${result.message}`);
    }
  } catch (err) {
    console.error('Validasi error:', err);
    alert('Terjadi kesalahan saat validasi PO.');
  }
};


const handleSelectRekanan = (selectedRekanan) => {
  setKdRekanan(selectedRekanan.KD_REKANAN);  
  setNamaRekanan(selectedRekanan.NAMAREKANAN);   
  setShowRekananLookup(false);
};


const handleSelectRute = (selectedRute) => {
  setKotaAsal(selectedRute.KOTA_ASAL);  
  setKotaTujuan(selectedRute.KOTA_TUJUAN);   
  setSubcity(selectedRute.SUBCITY);  
  setJnsKendaraan(selectedRute.JNS_KENDARAAN);    
  setJnsMuatan(selectedRute.JNS_MUATAN);  
  setShowRuteLookup(false);
};


  return (
  <div style={{ padding: '20px', backgroundColor: '#ffffff', borderRadius: '10px', boxShadow: '0 0 10px rgba(0,0,0,0.1)' }}>
    <h2 style={{ marginBottom: '20px', color: '#4A4A4A' }}>{title}</h2>

    {showRekananLookup && (
     <CariRekanan
      onSelect={handleSelectRekanan}
      onCancel={() => setShowRekananLookup(false)}
     />
    )}

    {showRuteLookup && (
      <CariRute
        kd_rekanan={kdRekanan}
        onSelect={handleSelectRute}
        onCancel={() => setShowRuteLookup(false)}
      />
    )}    

    {!showRekananLookup && !showRuteLookup && (
      <>
        <div>
          <label><strong>No Transaksi</strong></label>
          <input
            type="text"
            readOnly
            value={noTransaksi}
            style={{ width: '100%', padding: '8px', borderRadius: '5px', border: '1px solid #ccc', marginBottom: 10, backgroundColor: '#E6E6E6'  }}
          />
        </div>

        <div>
          <label><strong>Tanggal</strong></label>
          <input
            type="date"
            value={tglTransaksi}
            onChange={(e) => setTglTransaksi(e.target.value)}
            style={{ width: '100%', padding: '8px', borderRadius: '5px', border: '1px solid #ccc', marginBottom: 10 }}
          />
        </div>


        <div style={{ marginBottom: '10px' }}>
          <label>Rekanan:</label>
          <div style={{ display: 'flex', gap: '5px' }}>
            <input
              type="text"
              value={namaRekanan}
              readOnly
              style={{ flex: 1, padding: '5px', backgroundColor: '#E6E6E6'  } }
            />
            <button
              onClick={() => setShowRekananLookup(true)}
              disabled={status === '5' || status === '6'}
              style={{
                marginTop: '10px',
                marginBottom: '10px',
                padding: '5px 10px',
                backgroundColor: '#00A2E8',
                color: 'white',
                border: 'none',
                borderRadius: '5px',
                cursor: 'pointer',
              }}
            >
              Cari
            </button>
          </div>
        </div>

        <div style={{ marginBottom: '10px' }}>
          <label>Asal</label>
          <div style={{ display: 'flex', gap: '5px' }}>
            <input
              type="text"
              value={kotaAsal}
              readOnly
              style={{ flex: 1, padding: '5px', backgroundColor: '#E6E6E6'  }}
            />
            <button
              onClick={() => setShowRuteLookup(true)}
              disabled={status === '5' || status === '6'}
              style={{
                marginTop: '10px',
                marginBottom: '10px',
                padding: '5px 10px',
                backgroundColor: '#00A2E8',
                color: 'white',
                border: 'none',
                borderRadius: '5px',
                cursor: 'pointer',
              }}
            >
              Cari
            </button>
          </div>
        </div>

        <div>
        <label><strong>Tujuan</strong></label>
        <input
            type="text" readOnly
            value={kotaTujuan}
            onChange={(e) => setKotaTujuan(e.target.value)}
            style={{ width: '100%', padding: '8px', borderRadius: '5px', border: '1px solid #ccc', backgroundColor: '#E6E6E6'  }}
        />
        </div>    

        <div>
        <label><strong>Subcity</strong></label>
        <input
            type="text" readOnly
            value={subcity}
            onChange={(e) => setSubcity(e.target.value)}
            style={{ width: '100%', padding: '8px', borderRadius: '5px', border: '1px solid #ccc', backgroundColor: '#E6E6E6'  }}
        />
        </div>        

        <div>
        <label><strong>Kendaraan</strong></label>
        <input
            type="text" readOnly
            value={jnsKendaraan}  
            onChange={(e) => setJnsKendaraan(e.target.value)}
            style={{ width: '100%', padding: '8px', borderRadius: '5px', border: '1px solid #ccc', backgroundColor: '#E6E6E6'  }}
        />
        </div>

        <div>
        <label><strong>Muatan</strong></label>
        <input
            type="text" readOnly
            value={jnsMuatan}
            onChange={(e) => setJnsMuatan(e.target.value)}
            style={{ width: '100%', padding: '8px', borderRadius: '5px', border: '1px solid #ccc', backgroundColor: '#E6E6E6'  }}
        />
        </div>        

        <div>
        <label><strong>Tanggal PO</strong></label>
        <input
            type="date" 
            value={tglPo}
            onChange={(e) => setTglPo(e.target.value)}
            style={{ width: '100%', padding: '8px', borderRadius: '5px', border: '1px solid #ccc', marginBottom:10 }}
        />
        </div>

        <div>
        <label><strong>No. PO</strong></label>
        <input
            type="text" 
            value={noPo}
            onChange={(e) => setNoPo(e.target.value)}
            style={{ width: '100%', padding: '8px', borderRadius: '5px', border: '1px solid #ccc' }}
        />
        </div>             

        <div style={{ marginBottom: '10px' }}>
          <label>Via PO</label>
          <select
            value={viaPo}
            onChange={(e) => setViaPo(e.target.value)}
            style={{ width: '100%', padding: '5px', marginBottom: '10px' }}
          >
            <option value="PHONE">PHONE</option>
            <option value="MAIL">MAIL</option>
            <option value="OTHER">OTHER</option>
          </select>
        </div>        

        <div style={{ marginBottom: '20px' }}>
        <label><strong>Keterangan</strong></label>
        <textarea
            value={keterangan}
            onChange={(e) => setKeterangan(e.target.value)}
            rows={3}
            style={{ width: '100%', padding: '10px', borderRadius: '5px', border: '1px solid #ccc' }}
        />
        </div>

      
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>

          <button
            onClick={handleUnvalid}
            disabled={!canUnvalid || status === '5' || status === '6'}
            style={{
              backgroundColor: !canUnvalid || status === '5' || status === '6' ? '#A5D6A7' : 'red',
              color: 'white',
              padding: '10px 20px',
              border: 'none',
              borderRadius: '5px',
              cursor: !canUnvalid || status === '5' || status === '6' ? 'not-allowed' : 'pointer'
            }}
          >
            Un-valid
          </button>

          <button
            onClick={handleDelete}
            disabled={status === '9' || status === '5' || status === '6'}
            style={{
              backgroundColor: status === '9' || status === '5' || status === '6' ? '#A5D6A7' : 'red',
              color: 'white',
              padding: '10px 20px',
              border: 'none',
              borderRadius: '5px',
              cursor: status === '9' || status === '5' || status === '6' ? 'not-allowed' : 'pointer'
            }}
          >
            Delete
          </button>
                    
          <button
            onClick={onCancel}
            style={{
              backgroundColor: 'blue',
              color: 'white',
              padding: '10px 20px',
              border: 'none',
              borderRadius: '5px',
              cursor: 'pointer'
            }}
          >
            Batal
          </button>

          <button
            onClick={handleValidasi}
            disabled={status === '9' || status === '5' || status === '6'}
            style={{
              backgroundColor: status === '9' || status === '5' || status === '6' ? '#A5D6A7' : 'green',
              color: 'white',
              padding: '10px 20px',
              border: 'none',
              borderRadius: '5px',
              cursor: status === '9' || status === '5' || status === '6' ? 'not-allowed' : 'pointer'
            }}
          >
            Valid
          </button>
        </div>
      </>
    )}

  </div>    
  );
}

export default InputPo;
